<div class="d-flex align-items-center">
  <span class="fs-24 fw-4 me-1" *ngIf="showRateNumber">{{ rating | number:'1.1-1' }}</span>

  <ng-container *ngFor="let item of [].constructor(starNumber); let i = index">
    <div class="d-flex flex-column">
      <img class="me-1" [class]="(!readOnly && !disabled) ? 'cursor-pointer' : '' " [ngClass]="innerClass"
        [ngSrc]="getStarImage(i)" alt="" [height]="height" [width]="width" (click)="selectRating(i)" loading="lazy" fetchpriority="low">
      <p class="fs-13 fw-400 mt-2" *ngIf="showIndexNumber">{{ i + 1 }}</p>
    </div>
  </ng-container>
</div>